import Vue from 'vue';
import {
  mapState, mapMutations, mapActions, mapGetters,
} from 'vuex';
import JSZip from 'jszip';
import { mixinz } from '../../../../scripts/global/mixinz';
import * as api from '../../../../scripts/services/api';
import * as blockui from '../../../../helpers/block-ui';
import * as dateFormat from '../../../../helpers/dateFormat';
import { compareDates, downloadBlob } from '../../../../scripts/global/util';
import { hasPageAccess } from '../../../../scripts/services/authorization';
import * as workOrderStatusPolicy from '../../../../scripts/services/workOrderStatusPolicy';
import * as swal from '../../../../helpers/swal';

import Tabs from '../../../wrappers/TabView/Tabs/Tabs.vue';
import Tab from '../../../wrappers/TabView/Tab/Tab.vue';

import upload from '../../../shared/upload';
import WorkOrderFeedback from '../../WorkOrderFeedBack.vue';
import WorkOrderQaQcQuestion from '../../WorkOrderQaQcQuestion.vue';
import WorkOrderSparePart from '../../SparePartTab.vue';
import WorkOrderCard from './WorkOrderCard/WorkOrderCard';
import WorkOrderInventoryCard from './WorkOrderInventoryCard/WorkOrderInventoryCard';
import WorkOrdersAssignedUsers from './WorkOrderAssignedUsers/WorkOrderAssignedUsers';
import WorkOrderProcedures from './WorkOrderProcedures/WorkOrderProcedures';
import WorkOrderForms from './WorkOrderForms/WorkOrderForms';
import WorkOrderHistory from './WorkOrderHistory/WorkOrderHistory';
import { unBlockElement } from '../../../../helpers/block-ui';
import WorkOrderFailureModeTab from '../../FailureModeTab.vue';

export default {
  mixins: [mixinz],
  data() {
    return {
      workOrders: [],
      statuses: [],
      workOrderStatusChangeable: null,
      printFormList: [],
    };
  },
  components: {
    'work-order-card': WorkOrderCard,
    'work-order-inventory-card': WorkOrderInventoryCard,
    'work-order-assigned-users': WorkOrdersAssignedUsers,
    'work-order-procedures': WorkOrderProcedures,
    'work-order-forms': WorkOrderForms,
    'work-order-history': WorkOrderHistory,
    'work-order-spare-part': WorkOrderSparePart,
    'work-order-feedback': WorkOrderFeedback,
    'work-order-qaqc-question': WorkOrderQaQcQuestion,
    'work-order-failure-mode': WorkOrderFailureModeTab,
    tabs: Tabs,
    tab: Tab,

    upload,
  },
  props: ['workOrderId', 'from'],
  computed: {
    ...mapState({
      statusEnums: (state) => state.enums.workOrderStatus,
      formProcessStatus: (state) => state.enums.formProcessStatus,
      userCardList: (state) => state.user.userCardList,
      formPrintObjList: (state) => state.form.formPrintObjList,
      workOrderForms: (state) => state.work_order_forms.workOrderForms,
      workOrderSourceEnums: (state) => state.enums.workOrderSource,
    }),
    ...mapGetters({
      getWorkOrderForms: 'getWorkOrderForms',
    }),
  },
  async mounted() {
    const self = this;
    Vue.getMyWorkOrder = async () => {
      self.workOrders = [];
      blockui.pageBlock(self);
      try {
        const response = await api.getWorkOrderWithRelatedWorkOrders(self.workOrderId);
        if (!response.body) {
          throw new Error('Error');
        }
        self.workOrders = response.body.sort((a, b) => compareDates(a.ScheduledTime, b.ScheduledTime));
      } catch (e) {
        toastr.error(e.message);
      } finally {
        blockui.unBlockPage();
      }

      await api.getWorkOrderSuitableStatuses(self.workOrderId).then((res) => {
        self.workOrderStatusChangeable = res.body.length > 0;
      });
    };
    Vue.getMyWorkOrder();
    this.$eventHub.$on('flagCount', this.reloadTabCounts);
    this.$eventHub.$on('reloadTabCounts', this.reloadTabCounts);
    this.$eventHub.$emit('reloadTabCounts', { workOrderId: this.workOrderId });
    this.$eventHub.$on('changeWOStatus', ({
      workOrderId, workOrderStatusId, workOrderStatusName, workOrderStatusColorNo, isFormsAnswerable,
    }) => {
      const workOrder = self.workOrders.find((x) => x.Id = workOrderId);
      if (workOrder) {
        workOrder.OrderStatusName = workOrderStatusName;
        workOrder.OrderStatusId = workOrderStatusId;
        workOrder.ColorCode = workOrderStatusColorNo;
        workOrder.IsFormsAnswerable = isFormsAnswerable;
        workOrder.OrderSubStatusName = null;
        workOrder.OrderStatusNote = null;
        // todo: schupy
      }
    });
  },
  beforeDestroy() {
    this.$eventHub.$off('flagCount');
    this.$eventHub.$off('reloadTabCounts');
    this.$eventHub.$off('changeWOStatus');
  },
  methods: {
    ...mapMutations({
      addUserToUserCardList: 'addUserToUserCardList',
    }),
    ...mapActions({
      getPrintItem: 'getPrintItem',
      getWorkOrderFormsByWorkOrderId: 'getWorkOrderFormsByWorkOrderId',
    }),
    async getFormsOfWorkOrder(workOrderId) {
      await this.getWorkOrderFormsByWorkOrderId({ workOrderId });
      const workOrderForms = this.getWorkOrderForms.find((x) => x.workOrderId == workOrderId);
      return workOrderForms ? workOrderForms.forms : [];
    },
    /**
     * Atanmis personel duzenlenebilir mi? Statu kurali politika modulunde (sunucunun aynasi);
     * burada ona ekran yetkisi eklenir: ilk atamanin yapildigi ekranlarin yetkisi aranir, cunku
     * sonradan personel degistirmek ilk kez atamaktan daha genis bir yetki olmamali.
     */
    canEditAssignedUsers(workOrder) {
      return workOrderStatusPolicy.canEditAssignedUsers(workOrder.OrderSourceId, workOrder.OrderStatusId)
        && (hasPageAccess('add_work_order_page') || hasPageAccess('maintenance_plan_calendar_page'));
    },
    async reloadTabCounts({ workOrderId }) {
      const workOrder = this.workOrders.find((x) => x.Id == workOrderId);
      if (!workOrder) {
        return;
      }
      try {
        const response = await api.getWorkOrderPropertyCounts(workOrderId);
        Vue.set(workOrder, 'PropertyCounts', response.body);
      } catch (e) {
        toastr.error(e.message);
      }
    },
    showOnlyInvalidFormsToggle(workOrder) {
      Vue.set(workOrder, 'showOnlyInvalidForms', !workOrder.showOnlyInvalidForms);
    },
    goFrom() {
      const self = this;
      switch (self.from) {
        case 'MyWorkOrders':
          self.$router.push({ name: 'MyWorkOrders' });
          break;
        case 'PendingApprovalWorkOrder':
          self.$router.push({ name: 'PendingApprovalWorkOrder' });
          break;
        case 'Home':
          self.$router.push({ name: 'Home' });
          break;
        default:
          self.$router.back();
          break;
      }
    },
    getWorkOrderUserPositions(workOrder) {
      const self = this;
      const userPositions = {};
      if (
        workOrder.AssignedUsers
                && workOrder.AssignedUsers.length > 0
      ) {
        workOrder.AssignedUsers.forEach((user) => {
          userPositions[user.UserPositionId] = user.UserPosition;
        });
      }
      return userPositions;
    },
    async formatData(history) {
      const self = this;
      const resultData = [];
      history = history.sort((a, b) => compareDates(a.ModifiedDate ? a.ModifiedDate : a.CreatedDate, b.ModifiedDate ? b.ModifiedDate : b.CreatedDate));
      for (let i = 0; i < history.length; i++) {
        const currentItem = history[i];
        if (i === 0) {
          resultData.push({
            title: this.translate('created'),
            date: currentItem.ModifiedDate ? dateFormat.viewDateTimeFormat(currentItem.ModifiedDate) : dateFormat.viewDateTimeFormat(currentItem.CreatedDate),
            orderStatusName: currentItem.WorkOrderStatus,
            orderStatusColor: currentItem.ColorCode,
            message: this.translate('work_order_history_created').formatString(dateFormat.viewDateTimeFormat(currentItem.ScheduledTime), currentItem.Duration, currentItem.WorkOrderStatus),
            userId: currentItem.ModifiedUserId || currentItem.CreatedUserId,
            userName: currentItem.ModifiedUser || currentItem.CreatedUser,
          });
        } else {
          const previousItem = history[i - 1];
          let message = '';
          if (previousItem.ScheduledTime != currentItem.ScheduledTime) {
            message += this.translate('scheduled_time_history_updated').formatString(dateFormat.viewDateTimeFormat(previousItem.ScheduledTime), dateFormat.viewDateTimeFormat(currentItem.ScheduledTime));
          }
          if (previousItem.Duration != currentItem.Duration) {
            message += this.translate('duration_history_updated').formatString(previousItem.Duration, currentItem.Duration);
          }
          if (previousItem.WorkOrderStatus != currentItem.WorkOrderStatus) {
            message += this.translate('status_history_updated').formatString(previousItem.WorkOrderStatus, currentItem.WorkOrderStatus);
          }
          if (message == '') {
            continue;
          }
          resultData.push({
            title: this.translate('updated'),
            date: currentItem.ModifiedDate ? dateFormat.viewDateTimeFormat(currentItem.ModifiedDate) : dateFormat.viewDateTimeFormat(currentItem.CreatedDate),
            orderStatusName: currentItem.WorkOrderStatus,
            orderStatusColor: currentItem.ColorCode,
            message,
            userId: currentItem.ModifiedUserId || currentItem.CreatedUserId,
            userName: currentItem.ModifiedUser || currentItem.CreatedUser,
          });
        }
      }
      return resultData;
    },
    viewDateFormat(date) {
      return dateFormat.viewDateFormat(date);
    },
    async printByChecked(evt, workOrder) {
      const self = this;
      const printButtons = [
        {
          input: 'checkbox',
          cls: 'b-raised b-icon m-checkbox m-checkbox--bold m-checkbox--state-brand text-inherit',
          id: 'workOrderCard',
          text: self.translate('work_order'),
          checked: true,
        },
        {
          input: 'checkbox',
          cls: 'b-raised b-icon m-checkbox m-checkbox--bold m-checkbox--state-brand text-inherit',
          id: 'workOrderForms',
          text: self.translate('all_forms'),
          checked: false,
        },
      ];
      await swal.checkWithInputMultipleInputMultipleType(self, self.translate('please_select_your_download_request'), printButtons, 'warning', self.translate('yes'), self.translate('cancel'))
        .then(async (e) => {
          if (!e.value) return false;
          let base64PdfWorkOrderList = null;
          let formPdfs = null;
          self.printFormList = [];
          if (e.value.length == 1 && e.value.includes('workOrderCard')) {
            base64PdfWorkOrderList = self.printPromise(workOrder.Id);
            await self.downloadIt(base64PdfWorkOrderList, null, null, workOrder.WorkName);
          } else if (e.value.length == 1 && e.value.includes('workOrderForms') && workOrder.PropertyCounts && workOrder.PropertyCounts.FormCount > 0) {
            blockui.pageBlock();
            (await self.getFormsOfWorkOrder(workOrder.Id)).map((x) => {
              self.printFormList.push(
                { Id: x.Id, FormName: x.Name },
              );
            });
            // Formlar arası AYNI olan verileri (OperandType, CampusLogo, tüm FormSection'lar, approvals) tek sefer çek.
            const shared = await self.fetchSharedPrintData(self, self.printFormList.map((x) => x.Id));
            formPdfs = await Promise.all(self.printFormList.map((item) => self.getPrintItem({ formId: item.Id, self, shared })));
            await self.downloadIt(null, formPdfs, self.printFormList, workOrder.WorkName);
            blockui.unBlockPage();
          } else if (e.value.length == 2) {
            blockui.pageBlock();
            (await self.getFormsOfWorkOrder(workOrder.Id)).map((x) => {
              self.printFormList.push(
                { Id: x.Id, FormName: x.Name },
              );
            });
            const shared = await self.fetchSharedPrintData(self, self.printFormList.map((x) => x.Id));
            const result = await Promise.all([
              self.print(e, workOrder.Id), // Metin => self.printPromise(workOrder.Id),
              ...self.printFormList.map((item) => self.getPrintItem({ formId: item.Id, self, shared })),
            ]);
            const workOrderPdfBase64 = result.shift();
            await self.downloadIt(workOrderPdfBase64, result, self.printFormList, workOrder.WorkName);
            blockui.unBlockPage();
          }
        });
    },
    // Bir iş emrinin tüm formları için ORTAK olan (forma göre değişmeyen) verileri tek seferde çeker.
    // getPrintItem bunları `shared` ile alıp form başına tekrar çağrı yapmaz:
    //   OperandType/GetList (parametresiz), Campus/GetCampusLogo (workId sabit),
    //   FormSection/GetList (parametresiz → tüm bölümler + tip eşleşmesi; form başına client'ta filtrelenir),
    //   GetFormsApprovalsInformation (tüm formların onayları tek çağrıda; formId -> approvals map).
    // approvals çağrısı ağır olmadığından hemen tetiklenir ve form döngüsüyle ÖRTÜŞÜR (await edilmez).
    async fetchSharedPrintData(self, formIds) {
      const workId = self.workOrders[0].WorkId ? self.workOrders[0].WorkId : 0;
      const approvalsPromise = api.getFormsApprovalsInformation(self.workOrderId, formIds)
        .then((res) => (res.body && res.body.Data) || {});
      const [operandTypesRes, campusLogoRes, formSectionsRes] = await Promise.all([
        api.getOperandTypeList(),
        api.getCampusLogo(workId),
        api.getFormSectionList({}),
      ]);
      return {
        operandTypes: operandTypesRes.body,
        campusLogoResponse: campusLogoRes.body,
        allFormSections: formSectionsRes.body,
        approvalsPromise,
      };
    },
    downloadIt(workOrderPDFBase64, formPDFBase64List, printFormsList, workName) {
      const zip = new JSZip();
      let workOrderFolder = zip;
      if (workOrderPDFBase64) {
        workOrderFolder = zip.folder('WorkOrders');// workOrder birden çok gelebilir
        workOrderFolder.file(`${workName}.pdf`, workOrderPDFBase64, { base64: true });
      }
      if (formPDFBase64List) {
        const formsFolder = workOrderFolder.folder('WorkOrderForms');
        for (let i = 0; i < formPDFBase64List.length; i++) {
          formsFolder.file(`${printFormsList[i].FormName}` + '.pdf', formPDFBase64List[i], { base64: true });
        }
      }
      zip.generateAsync({
        type: 'blob',
      }).then((content) => {
        downloadBlob(content, 'WorkOrders.zip');
      });
    },

    async printPromise(workOrderId) {
      const self = this;
      blockui.pageBlock();
      let workOrder = {};
      const res = await api.getWorkOrderDetail(workOrderId);
      if (res.body.IsSuccess) {
        await api.getWorkOrderStatusList(null).then((res) => {
          self.statuses = res.body.Data;
        });

        workOrder = res.body.Data.find((x) => x.Id == workOrderId);

        const userPositions = this.getWorkOrderUserPositions(workOrder);
        const parsedUsersPosition = [];
        Object.keys(userPositions).map(async (key, index) => {
          let users = workOrder.AssignedUsers.filter((i) => i.UserPosition === userPositions[key]);
          users = await Promise.all(users.map(async (user) => {
            const userDetail = await api.getUserInfo(user.Id); //Metin => await api.getUser(user.Id);
            self.addUserToUserCardList(userDetail);
            user = {
              ...user,
              ...userDetail.body.Data,
            };
            return user;
          }));

          parsedUsersPosition.push({
            positionId: key,
            positionTitle: userPositions[key],
            users,
          });
        });
        Vue.set(workOrder, 'userPositions', parsedUsersPosition);

        const response = await this.$globalApiClient.workOrder.workOrderGetWorkOrderHistory({ workOrderId}); // Metin => this.$globalApiClient.workOrder.workOrderGetWorkOrderHistory({ workOrderId});
        const uniqueStatusTimeline = response.data;
        const parsedUniqueStatusTimeline = await self.formatData(uniqueStatusTimeline);
        Vue.set(workOrder, 'uniqueStatusTimeline', parsedUniqueStatusTimeline);
      }
      const tableLayout = {
        hLineWidth(i, node) {
          return i === 0 || i === node.table.body.length ? 2 : 1;
        },
        vLineWidth(i, node) {
          return i === 0 || i === node.table.widths.length ? 2 : 1;
        },
        hLineColor(i, node) {
          return i === 0 || i === node.table.body.length
            ? '#576472'
            : '#576472';
        },
        vLineColor(i, node) {
          return i === 0 || i === node.table.widths.length
            ? '#576472'
            : '#576472';
        },
      };
      const getTable = ({
        columns, data, params, id,
      }) => {
        const header = columns.map((column) => ({
          fillColor: '#eeeeee',
          text: column.title,
          style: 'tableHeader',
          alignment: 'center',
        }));

        const body = data.map((row) => columns.map((column) => ({ text: row[column.field], style: column.style })));

        const footer = columns.map((column) => ({
          text: column.sum ? column.sum(data.map((x) => x[column.field]), data) : '',
          style: 'tableFooter',
          fillColor: '#eeeeee',
        }));

        const tableContent = [
          header,
          ...body,
        ];

        const footerExist = footer.findIndex((x) => x.text) >= 0;
        if (footerExist) {
          tableContent.push(footer);
        }
        return {
          style: 'table',
          id,
          table: {
            widths: params.widths.map((width, i) => {
              if (width !== '?') {
                return width;
              }
              const isContentExist = data.some((row) => !!row[columns[i].field]);
              return isContentExist ? 'auto' : '*';
            }),
            headerRows: 1,
            body: tableContent,
          },
          layout: tableLayout,
        };
      };
      const procedures = [];
      /*
      const comments = [];
      const attachments = [];
      [
        { title: 'File 1' },
        { title: 'File 2' },
      ].map((i) => {
        attachments.push({
          text: i.title,
          style: 'attachments',
        });
      });
      [{
        comment: 'test',
        commented_by: 'commented_by',
        created_at: 'test',
        attached_pic: 'attached_pic',
      }].map((i) => {
        comments.push([
          {
            text: i.comment,
            style: 'tableField',
          },
          {
            text: i.commented_by,
            style: 'tableField',
          },
          {
            text: i.created_at,
            style: 'tableField',
          },
          {
            text: i.attached_pic,
            style: 'tableField',
          },
        ]);
      });
      */
      workOrder.Forms.map((i) => {
        procedures.push([
          {
            text: `${i.Id} - ${i.Name}`,
            style: 'tableField',
          },
          {
            text: i.ProcedureType ? i.ProcedureType.Name : '',
            style: 'tableField',
          },
          {
            text: i.Version,
            style: 'tableField',
          },
          {
            text: i.FormProcesses?.length > 0 
            ? i.FormProcesses.reduce((sum, fp) => sum + (fp.WorkOrderHtmlContents?.length || 0), 0)
            : '',
            style: 'tableField',
          },
          {
            //text: i.QuestionGroups.length,
            text: i.FormProcesses && i.FormProcesses.length > 0 
              ? i.FormProcesses.reduce((n, {InvalidAnswerCount}) => n + InvalidAnswerCount, 0) 
              : '' , 
            style: 'tableField',
          },
        ]);
      });
      const assignedStaffsTable = getTable({
        params: { widths: ['?', '*', '*'] },
        columns: [{
          title: this.translate('name'),
          field: 'NameSurname',
          style: 'assignedStaffsTableField',
          alignment: 'center',
        }, {
          title: this.translate('position'),
          field: 'UserPosition',
          style: 'assignedStaffsTableField',
          alignment: 'center',
        }, {
          title: this.translate('user_type'),
          field: 'UserTypeName',
          style: 'assignedStaffsTableField',
          alignment: 'center',
        }],
        data: workOrder.AssignedUsers.map((users) => ({
          ...users,
        })),
      });
      const approvedStaffsTable = getTable({
        params: { widths: ['?', '*', '?', '*'] },
        columns: [{
          title: this.translate('responsible'),
          field: 'WhoSendToApprove',
          style: 'approvedStaffsTableField',
        }, {
          title: this.translate('signature'),
          style: 'approvedStaffsTableField',
        }, {
          title: this.translate('confirmed_by'),
          field: 'WhoApproved',
          style: 'approvedStaffsTableField',
        }, {
          title: this.translate('signature'),
          style: 'approvedStaffsTableField',
        }],
        data: [workOrder],
      });
      const workOrderTimeline = (data = workOrder.uniqueStatusTimeline) => {
        const rows = [];
        for (let i = 0; i < data.length; i += 4) {
          const row = [];
          for (let j = 0; j < 4; j++) {
            if (i + j < data.length) {
              if (j > 0) {
                row.push({
                  border: [false, false, false, false],
                  style: 'timeline',
                  stack: [
                    {
                      canvas: [
                        {
                          type: 'line',
                          x1: -10,
                          y1: 50,
                          x2: 15,
                          y2: 50,
                          lineWidth: 5,
                        },
                      ],
                    },
                    {
                      image: 'data:image/png;base64,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',
                      fit: [20, 20],
                      relativePosition: { x: 10, y: -10 },
                    },
                  ],
                });
              }

              row.push({
                border: [false, false, false, false],
                style: 'timeline',
                stack: [
                  {
                    canvas: [
                      {
                        type: 'rect',
                        w: 100,
                        x: 0,
                        y: 0,
                        h: 100,
                        r: 10,
                        color: data[i + j].orderStatusColor,
                      },
                    ],
                  },
                  {
                    text: data[i + j].orderStatusName,
                    bold: true,
                    fontSize: 9,
                    color: '#000000',
                    relativePosition: { x: 10, y: -75 },
                  },
                  {
                    text: data[i + j].userName,
                    bold: false,
                    fontSize: 9,
                    color: '#000000',
                    relativePosition: { x: 10, y: -60 },
                  },
                  {
                    text: data[i + j].date,
                    bold: false,
                    fontSize: 7,
                    color: '#000000',
                    relativePosition: { x: 10, y: -25 },
                  },
                ],
              });
            } else {
              if (j > 0) {
                row.push(
                  {
                    border: [false, false, false, false],
                    text: '',
                  },
                );
              }
              row.push({
                border: [false, false, false, false],
                text: '',
              });
            }
          }
          rows.push(row);
        }
        return {
          margin: [0, 0, 0, 10],
          table: {
            body: rows,
          },
        };
      };
      const dd = {
        content: [
          {
            text: `${workOrder.BreadCrumb ? `${workOrder.BreadCrumb},` : ''} ${workOrder.WorkName ? workOrder.WorkName : ''}`,
            style: 'header',
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 5,
                x2: 585 - 2 * 40,
                y2: 5,
                lineWidth: 1,
                lineColor: '#576472',
              },
            ],
          },
          {
            text: '',
            style: 'emptySpace',
          },
          approvedStaffsTable,
          {
            text: '',
            style: 'emptySpace',
          },
          {
            style: 'table',
            table: {
              headerRows: 1,
              widths: [80, 90, 95, 95, 100],
              heights: [20, 20, 20, 20, 20],
              body: [
                [
                  {
                    fillColor: '#eeeeee',
                    text: `${this.translate('work_order')} No`,
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('work_order_type'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('status'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('description'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('main_work_order_number'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
                [
                  { text: workOrder.Id, style: 'tableField' },
                  { text: workOrder.WorkCategory, style: 'tableField' },
                  { text: workOrder.OrderStatusName, style: 'tableField' },
                  { text: workOrder.Description, style: 'tableField' },
                  { text: workOrder.ParentId, style: 'tableField' },
                ],
              ],
            },
            layout: tableLayout,
          },
          {
            text: '',
            style: 'emptySpace2x',
          },
          workOrderTimeline(),
          {
            text: '',
            style: 'emptySpace5x',
          },
          {
            style: 'table',
            table: {
              headerRows: 1,
              widths: [120, 110, 120, 120],
              heights: [20, 20, 20, 20],
              body: [
                [
                  {
                    // border: [false, true, false, false],
                    fillColor: '#eeeeee',
                    text: this.translate('scheduled_date'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('estimated_duration'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('actual_date'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('actual_duration'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
                [
                  {
                    text: this.viewDateFormat(workOrder.ScheduledTime),
                    style: 'tableField',
                  },
                  {
                    text: `${workOrder.Duration} ${this.translate(
                      'abbreviation_minute',
                    )}`,
                    style: 'tableField',
                  },
                  {
                    text: this.viewDateFormat(workOrder.StartedDate) ? this.viewDateFormat(workOrder.StartedDate) : '',
                    style: 'tableField',
                  },
                  {
                    text: workOrder.SpentTimeMinutes ? `${workOrder.SpentTimeMinutes} min ` : '',
                    style: 'tableField',
                  },
                ],
              ],
            },
            layout: tableLayout,

          },
          {
            id: 'inventory_information',
            width: '*',
            stack: [
              {
                text: this.translate('inventory_information'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              {
                text: '',
                style: 'emptySpace',
              },
              {
                style: 'table',
                table: {
                  headerRows: 1,
                  widths: [80, 90, 95, 95, 100],
                  heights: [20, 20, 20, 20, 20],
                  body: [
                    [
                      {
                        // border: [false, true, false, false],
                        fillColor: '#eeeeee',
                        text: this.translate('room_capacity_equipment'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('capacity_type'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: `${this.translate('campus')}/${this.translate('location')}`,
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('end_of_maintenance_contract'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('end_of_guarantee_time'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                    ],
                    [
                      {
                        text: workOrder.BreadCrumb,
                        style: 'tableField',
                      },
                      {
                        text: workOrder.CapacityTypeName,
                        style: 'tableField',
                      },
                      { text: workOrder.BreadCrumbWithCampus, style: 'tableField' },
                      { text: '-', style: 'tableField' },
                      { text: '-', style: 'tableField' },
                    ],
                  ],
                },
                layout: tableLayout,
              },
            ],
          },
          {
            id: 'assigned_staffs',
            width: '*',
            stack: [
              {
                text: this.translate('assigned_staffs'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              {
                text: '',
                style: 'emptySpace',
              },
              assignedStaffsTable,
            ],
          },
          {
            id: 'procedures',
            width: '*',
            stack: [
              {
                text: this.translate('procedures'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              {
                text: '',
                style: 'emptySpace',
              },
              {
                style: 'table',
                table: {
                  headerRows: 1,
                  widths: [80, 90, 95, 95, 100],
                  heights: [20, 20, 20, 20, 20],
                  body: [
                    [
                      {
                        // border: [false, true, false, false],
                        fillColor: '#eeeeee',
                        text: `ID -${this.translate('name')}`,
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('type'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('version'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('number_of_flag'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('number_of_abnormal_answers'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                    ],
                    ...procedures,
                  ],
                },
                layout: tableLayout,
              },
            ],
          },
          /*
          {
            id: 'comments',
            width: '*',
            stack: [
              {
                text: this.translate('comments'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              {
                text: '',
                style: 'emptySpace',
              },
              {
                style: 'table',
                table: {
                  headerRows: 1,
                  widths: [120, 110, 120, 120],
                  heights: [20, 20, 20, 20],
                  body: [
                    [
                      {
                        // border: [false, true, false, false],
                        fillColor: '#eeeeee',
                        text: this.translate('comment'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('commented_by'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('commented_at'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: `${this.translate('attached_pic')}/${this.translate('file')}`,
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                    ],
                    ...comments,
                  ],
                },
                layout: tableLayout,
              },
            ],
          },
          {
            id: 'attachments',
            width: '*',
            stack: [
              {
                text: this.translate('attachments'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              ...attachments,
            ],
          },
          */
        ],
        styles: {
          header: {
            fontSize: 14,
            bold: true,
            margin: [0, 0, 0, 5],
            color: '#243951',
          },
          /*
          attachments: {
            fontSize: 10,
            bold: true,
            margin: [0, 6, 0, 0],
            color: '#243951',
          },
          */
          subHeader: {
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5],
            color: '#243951',
          },
          emptySpace: {
            margin: [0, 0, 0, 10],
          },
          emptySpace2x: {
            margin: [20, 0, 0, 20],
          },
          emptySpace3x: {
            margin: [30, 0, 0, 30],
          },
          emptySpace4x: {
            margin: [40, 0, 0, 40],
          },
          emptySpace5x: {
            margin: [50, 0, 0, 50],
          },
          table: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 10,
            color: '#243951',
          },
          tableField: {
            bold: false,
            fontSize: 9,
            color: '#576472',
          },
          assignedStaffsTableField: {
            bold: false,
            fontSize: 11,
            color: '#576472',
            margin: 2.5,
            alignment: 'center',
          },
          approvedStaffsTableField: {
            bold: false,
            fontSize: 11,
            margin: [10, 15, 10, 15],
            color: '#576472',
            alignment: 'center',
          },
          timelineStatus: {
            bold: true,
            fontSize: 7,
            color: '#fff',
          },
          timelineStatusDate: {
            bold: false,
            fontSize: 5,
            color: '#fff',
          },
        },
        pageSize: 'A4',
        pageBreakBefore(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
          /*
          if (currentNode.id === 'attachments' || currentNode.id === 'comments' || currentNode.id === 'inventory_information'
                        || currentNode.id === 'procedures' || currentNode.id === 'assigned_staffs' || currentNode.style === 'timeline') {
          */
          if (currentNode.id === 'inventory_information' || currentNode.id === 'procedures' || currentNode.id === 'assigned_staffs' || currentNode.style === 'timeline') {
            return currentNode.pageNumbers.length > 1;
          }
          return false;
        },
      };
      return new Promise((resolve, reject) => {
        try {
          pdfMake.createPdf(dd).getBase64((data) => {
            resolve(data);
            blockui.unBlockPage();
          });
        } catch (e) {
          blockui.unBlockPage();
          reject(e);
        }
      });
    },
    // TODO - Eren : Burn It With Fire And Refactor.
    async print(e, workOrderId) {
      const self = this;
      blockui.blockElementPromise(self, self.$el);
      let workOrder = {};
      const res = await api.getWorkOrderDetail(workOrderId);
      if (res.body.IsSuccess) {
        await api.getWorkOrderStatusList(null).then((res) => {
          self.statuses = res.body.Data;
        });

        workOrder = res.body.Data.find((x) => x.Id == workOrderId);

        const userPositions = this.getWorkOrderUserPositions(workOrder);
        const parsedUsersPosition = [];
        Object.keys(userPositions).map(async (key, index) => {
          let users = workOrder.AssignedUsers.filter((i) => i.UserPosition === userPositions[key]);
          users = await Promise.all(users.map(async (user) => {
            const userDetail = await api.getUserInfo(user.Id); // Metin => await api.getUser(user.Id);
            self.addUserToUserCardList(userDetail);
            user = {
              ...user,
              ...userDetail.body.Data,
            };
            return user;
          }));

          parsedUsersPosition.push({
            positionId: key,
            positionTitle: userPositions[key],
            users,
          });
        });
        Vue.set(workOrder, 'userPositions', parsedUsersPosition);

        const response = await this.$globalApiClient.workOrder.workOrderGetWorkOrderHistory({ workOrderId});
        const uniqueStatusTimeline = response.data;
        const parsedUniqueStatusTimeline = await self.formatData(uniqueStatusTimeline);
        Vue.set(workOrder, 'uniqueStatusTimeline', parsedUniqueStatusTimeline);
      }

      const tableLayout = {
        hLineWidth(i, node) {
          return i === 0 || i === node.table.body.length ? 2 : 1;
        },
        vLineWidth(i, node) {
          return i === 0 || i === node.table.widths.length ? 2 : 1;
        },
        hLineColor(i, node) {
          return i === 0 || i === node.table.body.length
            ? '#576472'
            : '#576472';
        },
        vLineColor(i, node) {
          return i === 0 || i === node.table.widths.length
            ? '#576472'
            : '#576472';
        },
      };
      const getTable = ({
        columns, data, params, id,
      }) => {
        const header = columns.map((column) => ({
          fillColor: '#eeeeee',
          text: column.title,
          style: 'tableHeader',
          alignment: 'center',
        }));

        const body = data.map((row) => columns.map((column) => ({ text: row[column.field], style: column.style })));

        const footer = columns.map((column) => ({
          text: column.sum ? column.sum(data.map((x) => x[column.field]), data) : '',
          style: 'tableFooter',
          fillColor: '#eeeeee',
        }));

        const tableContent = [
          header,
          ...body,
        ];

        const footerExist = footer.findIndex((x) => x.text) >= 0;
        if (footerExist) {
          tableContent.push(footer);
        }
        return {
          style: 'table',
          id,
          table: {
            widths: params.widths.map((width, i) => {
              if (width !== '?') {
                return width;
              }
              const isContentExist = data.some((row) => !!row[columns[i].field]);
              return isContentExist ? 'auto' : '*';
            }),
            headerRows: 1,
            body: tableContent,
          },
          layout: tableLayout,
        };
      };
      const procedures = [];
      /*
      const comments = [];
      const attachments = [];
      [
        { title: 'File 1' },
        { title: 'File 2' },
      ].map((i) => {
        attachments.push({
          text: i.title,
          style: 'attachments',
        });
      });

      [{
        comment: 'test',
        commented_by: 'commented_by',
        created_at: 'test',
        attached_pic: 'attached_pic',
      }].map((i) => {
        comments.push([
          {
            text: i.comment,
            style: 'tableField',
          },
          {
            text: i.commented_by,
            style: 'tableField',
          },
          {
            text: i.created_at,
            style: 'tableField',
          },
          {
            text: i.attached_pic,
            style: 'tableField',
          },
        ]);
      });
      */
      workOrder.Forms.map((i) => {
        procedures.push([
          {
            text: `${i.Id} - ${i.Name}`,
            style: 'tableField',
          },
          {
            text: i.ProcedureType ? i.ProcedureType.Name : '',
            style: 'tableField',
          },
          {
            text: i.Version,
            style: 'tableField',
          },
          {
            text: i.FormProcesses?.length > 0 
            ? i.FormProcesses.reduce((sum, fp) => sum + (fp.WorkOrderHtmlContents?.length || 0), 0)
            : '',     
            style: 'tableField',
          },
          {
            //text: i.QuestionGroups.length,
            text: i.FormProcesses && i.FormProcesses.length > 0 
            ? i.FormProcesses.reduce((n, {InvalidAnswerCount}) => n + InvalidAnswerCount, 0) 
            : '' , 
            style: 'tableField',
          },
        ]);
      });
      // Metin => commented by Metin. e.preventDefault and e.stopPropagation lines
      //e.preventDefault();
      //e.stopPropagation();
      const assignedStaffsTable = getTable({
        params: { widths: ['?', '*', '*'] },
        columns: [{
          title: this.translate('name'),
          field: 'NameSurname',
          style: 'assignedStaffsTableField',
          alignment: 'center',
        }, {
          title: this.translate('position'),
          field: 'UserPosition',
          style: 'assignedStaffsTableField',
          alignment: 'center',
        }, {
          title: this.translate('user_type'),
          field: 'UserTypeName',
          style: 'assignedStaffsTableField',
          alignment: 'center',
        }],
        data: workOrder.AssignedUsers.map((users) => ({
          ...users,
        })),
      });
      const approvedStaffsTable = getTable({
        params: { widths: ['?', '*', '?', '*'] },
        columns: [{
          title: this.translate('responsible'),
          field: 'WhoSendToApprove',
          style: 'approvedStaffsTableField',
        }, {
          title: this.translate('signature'),
          style: 'approvedStaffsTableField',
        }, {
          title: this.translate('confirmed_by'),
          field: 'WhoApproved',
          style: 'approvedStaffsTableField',
        }, {
          title: this.translate('signature'),
          style: 'approvedStaffsTableField',
        }],
        data: [workOrder],
      });
      const workOrderTimeline = (data = workOrder.uniqueStatusTimeline) => {
        const rows = [];
        for (let i = 0; i < data.length; i += 4) {
          const row = [];
          for (let j = 0; j < 4; j++) {
            if (i + j < data.length) {
              if (j > 0) {
                row.push({
                  border: [false, false, false, false],
                  style: 'timeline',
                  stack: [
                    {
                      canvas: [
                        {
                          type: 'line',
                          x1: -10,
                          y1: 50,
                          x2: 15,
                          y2: 50,
                          lineWidth: 5,
                        },
                      ],
                    },
                    {
                      image: 'data:image/png;base64,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',
                      fit: [20, 20],
                      relativePosition: { x: 10, y: -10 },
                    },
                  ],
                });
              }

              row.push({
                border: [false, false, false, false],
                style: 'timeline',
                stack: [
                  {
                    canvas: [
                      {
                        type: 'rect',
                        w: 100,
                        x: 0,
                        y: 0,
                        h: 100,
                        r: 10,
                        color: data[i + j].orderStatusColor,
                      },
                    ],
                  },
                  {
                    text: data[i + j].orderStatusName,
                    bold: true,
                    fontSize: 9,
                    color: '#000000',
                    relativePosition: { x: 10, y: -75 },
                  },
                  {
                    text: data[i + j].userName,
                    bold: false,
                    fontSize: 9,
                    color: '#000000',
                    relativePosition: { x: 10, y: -60 },
                  },
                  {
                    text: data[i + j].date,
                    bold: false,
                    fontSize: 7,
                    color: '#000000',
                    relativePosition: { x: 10, y: -25 },
                  },
                ],
              });
            } else {
              if (j > 0) {
                row.push(
                  {
                    border: [false, false, false, false],
                    text: '',
                  },
                );
              }
              row.push({
                border: [false, false, false, false],
                text: '',
              });
            }
          }
          rows.push(row);
        }
        return {
          margin: [0, 0, 0, 10],
          table: {
            body: rows,
          },
        };
      };
      const dd = {
        content: [
          {
            text: `${workOrder.BreadCrumb ? `${workOrder.BreadCrumb},` : ''} ${workOrder.WorkName ? workOrder.WorkName : ''}`,
            style: 'header',
          },
          {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 5,
                x2: 585 - 2 * 40,
                y2: 5,
                lineWidth: 1,
                lineColor: '#576472',
              },
            ],
          },
          {
            text: '',
            style: 'emptySpace',
          },
          approvedStaffsTable,
          {
            text: '',
            style: 'emptySpace',
          },
          {
            style: 'table',
            table: {
              headerRows: 1,
              widths: [80, 90, 95, 95, 100],
              heights: [20, 20, 20, 20, 20],
              body: [
                [
                  {
                    fillColor: '#eeeeee',
                    text: `${this.translate('work_order')} No`,
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('work_order_type'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('status'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('description'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('main_work_order_number'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
                [
                  { text: workOrder.Id, style: 'tableField' },
                  { text: workOrder.WorkCategory, style: 'tableField' },
                  { text: workOrder.OrderStatusName, style: 'tableField' },
                  { text: workOrder.Description, style: 'tableField' },
                  { text: workOrder.ParentId, style: 'tableField' },
                ],
              ],
            },
            layout: tableLayout,
          },
          {
            text: '',
            style: 'emptySpace2x',
          },
          workOrderTimeline(),
          {
            text: '',
            style: 'emptySpace5x',
          },
          {
            style: 'table',
            table: {
              headerRows: 1,
              widths: [120, 110, 120, 120],
              heights: [20, 20, 20, 20],
              body: [
                [
                  {
                    // border: [false, true, false, false],
                    fillColor: '#eeeeee',
                    text: this.translate('scheduled_date'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('estimated_duration'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('actual_date'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                  {
                    fillColor: '#eeeeee',
                    text: this.translate('actual_duration'),
                    style: 'tableHeader',
                    alignment: 'center',
                  },
                ],
                [
                  {
                    text: this.viewDateFormat(workOrder.ScheduledTime),
                    style: 'tableField',
                  },
                  {
                    text: `${workOrder.Duration} ${this.translate(
                      'abbreviation_minute',
                    )}`,
                    style: 'tableField',
                  },
                  {
                    text: this.viewDateFormat(workOrder.StartedDate) ? this.viewDateFormat(workOrder.StartedDate) : '',
                    style: 'tableField',
                  },
                  {
                    text: workOrder.SpentTimeMinutes ? `${workOrder.SpentTimeMinutes} min ` : '',
                    style: 'tableField',
                  },
                ],
              ],
            },
            layout: tableLayout,

          },
          {
            id: 'inventory_information',
            width: '*',
            stack: [
              {
                text: this.translate('inventory_information'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              {
                text: '',
                style: 'emptySpace',
              },
              {
                style: 'table',
                table: {
                  headerRows: 1,
                  widths: [80, 90, 95, 95, 100],
                  heights: [20, 20, 20, 20, 20],
                  body: [
                    [
                      {
                        // border: [false, true, false, false],
                        fillColor: '#eeeeee',
                        text: this.translate('room_capacity_equipment'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('capacity_type'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: `${this.translate('campus')}/${this.translate('location')}`,
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('end_of_maintenance_contract'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('end_of_guarantee_time'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                    ],
                    [
                      {
                        text: workOrder.BreadCrumb,
                        style: 'tableField',
                      },
                      {
                        text: workOrder.CapacityTypeName,
                        style: 'tableField',
                      },
                      { text: workOrder.BreadCrumbWithCampus, style: 'tableField' },
                      { text: '-', style: 'tableField' },
                      { text: '-', style: 'tableField' },
                    ],
                  ],
                },
                layout: tableLayout,
              },
            ],
          },
          {
            id: 'assigned_staffs',
            width: '*',
            stack: [
              {
                text: this.translate('assigned_staffs'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              {
                text: '',
                style: 'emptySpace',
              },
              assignedStaffsTable,
            ],
          },
          {
            id: 'procedures',
            width: '*',
            stack: [
              {
                text: this.translate('procedures'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              {
                text: '',
                style: 'emptySpace',
              },
              {
                style: 'table',
                table: {
                  headerRows: 1,
                  widths: [80, 90, 95, 95, 100],
                  heights: [20, 20, 20, 20, 20],
                  body: [
                    [
                      {
                        // border: [false, true, false, false],
                        fillColor: '#eeeeee',
                        text: `ID -${this.translate('name')}`,
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('type'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('version'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('number_of_flag'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('number_of_abnormal_answers'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                    ],
                    ...procedures,
                  ],
                },
                layout: tableLayout,
              },
            ],
          },
          /*
          {
            id: 'comments',
            width: '*',
            stack: [
              {
                text: this.translate('comments'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              {
                text: '',
                style: 'emptySpace',
              },
              {
                style: 'table',
                table: {
                  headerRows: 1,
                  widths: [120, 110, 120, 120],
                  heights: [20, 20, 20, 20],
                  body: [
                    [
                      {
                        // border: [false, true, false, false],
                        fillColor: '#eeeeee',
                        text: this.translate('comment'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('commented_by'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: this.translate('commented_at'),
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                      {
                        fillColor: '#eeeeee',
                        text: `${this.translate('attached_pic')}/${this.translate('file')}`,
                        style: 'tableHeader',
                        alignment: 'center',
                      },
                    ],
                    ...comments,
                  ],
                },
                layout: tableLayout,
              },
            ],
          },
          {
            id: 'attachments',
            width: '*',
            stack: [
              {
                text: this.translate('attachments'),
                style: 'subHeader',
              },
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 5,
                    x2: 585 - 2 * 40,
                    y2: 5,
                    lineWidth: 1,
                    lineColor: '#576472',
                  },
                ],
              },
              ...attachments,
            ],
          },
          */
        ],
        styles: {
          header: {
            fontSize: 14,
            bold: true,
            margin: [0, 0, 0, 5],
            color: '#243951',
          },
          /*
          attachments: {
            fontSize: 10,
            bold: true,
            margin: [0, 6, 0, 0],
            color: '#243951',
          },
          */
          subHeader: {
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5],
            color: '#243951',
          },
          emptySpace: {
            margin: [0, 0, 0, 10],
          },
          emptySpace2x: {
            margin: [20, 0, 0, 20],
          },
          emptySpace3x: {
            margin: [30, 0, 0, 30],
          },
          emptySpace4x: {
            margin: [40, 0, 0, 40],
          },
          emptySpace5x: {
            margin: [50, 0, 0, 50],
          },
          table: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 10,
            color: '#243951',
          },
          tableField: {
            bold: false,
            fontSize: 9,
            color: '#576472',
          },
          assignedStaffsTableField: {
            bold: false,
            fontSize: 11,
            color: '#576472',
            margin: 2.5,
            alignment: 'center',
          },
          approvedStaffsTableField: {
            bold: false,
            fontSize: 11,
            margin: [10, 15, 10, 15],
            color: '#576472',
            alignment: 'center',
          },
          timelineStatus: {
            bold: true,
            fontSize: 7,
            color: '#fff',
          },
          timelineStatusDate: {
            bold: false,
            fontSize: 5,
            color: '#fff',
          },
        },
        pageSize: 'A4',
        pageBreakBefore(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
          /*
          if (currentNode.id === 'attachments' || currentNode.id === 'comments' || currentNode.id === 'inventory_information'
                        || currentNode.id === 'procedures' || currentNode.id === 'assigned_staffs' || currentNode.style === 'timeline') {
          */
          if (currentNode.id === 'inventory_information' || currentNode.id === 'procedures' || currentNode.id === 'assigned_staffs' || currentNode.style === 'timeline') {
            return currentNode.pageNumbers.length > 1;
          }
          return false;
        },
      };
      try {
        pdfMake.createPdf(dd).print();
      } catch (e) {
        blockui.unBlockElement(self.$el);
      }
      blockui.unBlockElement(self.$el);
      return false;
    },
  },
};
